






















import { Component, Vue, Mixins } from "vue-property-decorator";
import { getCarousel, deleteCarouselItem } from "@/api/system";
import { Carousel } from "@/types/api/system";
import copy from "@/utils/deepCopy";
import Loading from "@/mixins/loading";

@Component
export default class Dialog extends Mixins(Loading) {
  list: Array<Carousel> = [];

  mounted() {
    this.getCarouselList();
  }

  // 获取轮播图列表
  getCarouselList() {
    this.showLoading();
    getCarousel({
      type: 1, // type = 1、首页轮播图片，type= 2、会员轮播图片
    }).then((res: any) => {
      this.list = res.data;
      this.hideLoading();
    });
  }
  // 删除
  handleDelete(item: Carousel) {
    this.$confirm("是否要删除该轮播图?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }).then(() => {
      deleteCarouselItem({ id: item.id }).then((res: any) => {
        this.$message.success("删除成功");
        this.getCarouselList();
      });
    });
  }
}
